import { Badge } from '../../../design-system/components/Badge';
import { Card } from '../../../design-system/components/Card';
import { EmptyState } from '../../../shared/components/EmptyState';
import type { Insight } from '../api';

interface ReadOnlyInsightsProps {
  insights: readonly Insight[] | null | undefined;
}

const CATEGORY_LABEL: Record<string, string> = {
  preco: 'Preço',
  tecnica: 'Técnica',
  concorrente: 'Concorrente',
  talk_ratio: 'Talk ratio',
  monologo: 'Monólogo',
  interesse_alto: 'Interesse alto',
  desinteresse: 'Desinteresse',
  mudanca_sentimento: 'Mudança de sentimento',
  pedido_dado: 'Pedido de dado',
};

const SEVERITY_VARIANT: Record<Insight['severity'], 'neutral' | 'accent' | 'warning' | 'danger'> = {
  low: 'neutral',
  medium: 'accent',
  high: 'danger',
};

export function ReadOnlyInsights({ insights }: ReadOnlyInsightsProps) {
  if (insights === null || insights === undefined || insights.length === 0) {
    return <EmptyState title="Sem insights" description="Esta reunião ainda não gerou insights." />;
  }
  return (
    <div className="dash-insights">
      {insights.map((ins) => (
        <Card key={ins.id}>
          <div className="dash-insights__header">
            <Badge variant={SEVERITY_VARIANT[ins.severity]}>
              {CATEGORY_LABEL[ins.category] ?? ins.category}
            </Badge>
            <h3 className="dash-insights__title">{ins.title}</h3>
          </div>
          <p className="dash-insights__body">{ins.body}</p>
          {ins.suggestion !== null && ins.suggestion !== undefined ? (
            <p className="muted dash-insights__suggestion">
              <strong>Sugestão:</strong> {ins.suggestion}
            </p>
          ) : null}
        </Card>
      ))}
    </div>
  );
}
